export type Interval = {
    from: number
    to: number
}

/**
 * Helper function for creating an interval object.
 */
export function interval(from: number, to: number) {
    return {
        from,
        to
    }
}

/**
 * Checks if the given value is inside the given interval.
 *
 * @param inclusive Defaults to true, if false, the given value cannot
 * be the same as the from/to values of the given interval.
 *
 * @example
 * isInsideInterval({from: 0, to: 10}, 0)         // => true
 * isInsideInterval({from: 0, to: 10}, 5)         // => true
 * isInsideInterval({from: 0, to: 10}, 10)        // => true
 *
 * isInsideInterval({from: 0, to: 10}, 0, false)  // => false
 * isInsideInterval({from: 0, to: 10}, 10, false) // => false
 */
export function isInsideInterval({ interval, value, inclusive = true }: {
    interval: Interval
    value: number
    inclusive: boolean
}) {
    if (inclusive) {
        return (
            value >= interval.from &&
            value <= interval.to
        )
    }

    return (
        value > interval.from &&
        value < interval.to
    )
}

/**
 * Returns true if the given value is inside any of the given
 * intervals.
 */
export function isInsideAnyInterval({ intervals, value, inclusive = true }: {
    intervals: Interval[]
    value: number
    inclusive: boolean
}) {
    return intervals.some(interval => isInsideInterval({ interval, value, inclusive }))
}
